import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Form from "@saleor/components/Form";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { MallErrorFragment } from "@saleor/fragments/types/MallErrorFragment";
import { hasNoError, useValidation } from "@saleor/utils/validators/malls";
import React, { useState } from "react";

import MallInfo from "../MallInfo";
export interface ErrorValidation {
  code: string;
  contactPerson: string;
  email: string;
  latitude: string;
  longitude: string;
  mallClosing: string;
  mallOpening: string;
  mobileNo: string;
  name: string;
  serviceArea: number;
  smMarketExternalCode: string;
  smMarketExternalId: number;
  smMarketExternalName: string;
  telephoneNo: string;
  totalLandArea: number;
  city: string;
  provinceCode: string;
}
export interface MallCreatePageFormData {
  code: string;
  contactPerson: string;
  email: string;

  expressDeliveryAvailable: boolean;
  expressLongDistanceAvailable: boolean;
  foodAndBevCutoffTime: string;
  genMerchCutoffTime: string;
  groceryCutoffTime: string;

  isActive: boolean;
  isInMallPickup: boolean;
  isNationwideDelivery: boolean;
  latitude: string;
  longitude: string;
  mallClosing: string;
  mallOpening: string;
  mobileNo: string;
  name: string;
  sameDayGmCutoffTime: string;
  nextDayAvailable: boolean;
  sameDayAvailable: boolean;
  serviceArea: string;
  smMarketExternalCode: string;
  smMarketExternalId: number;
  smMarketExternalName: string;
  totalLandArea: string;
  telephoneNo: string;

  city: string;
  provinceCode: string;
  provinceName: string;
}

const initialForm: MallCreatePageFormData = {
  city: "",
  code: "",
  contactPerson: "",
  email: "",
  expressDeliveryAvailable: true,
  expressLongDistanceAvailable: true,
  foodAndBevCutoffTime: "19:00",
  genMerchCutoffTime: "17:00",
  groceryCutoffTime: "19:00",
  isActive: false,
  isInMallPickup: true,
  isNationwideDelivery: true,
  latitude: "",
  longitude: "",
  mallClosing: "",
  mallOpening: "",
  mobileNo: "",
  name: "",
  nextDayAvailable: true,
  provinceCode: "",
  provinceName: "",
  sameDayAvailable: true,
  sameDayGmCutoffTime: "16:00",
  serviceArea: null,
  smMarketExternalCode: "",
  smMarketExternalId: null,
  smMarketExternalName: "",
  telephoneNo: "",
  totalLandArea: null
};

export interface MallCreatePageProps {
  /** Form state / Flags */
  disabled: boolean;
  errors: MallErrorFragment[];
  saveButtonBarState: ConfirmButtonTransitionState;
  hasManageMallPermission: boolean;

  /** Callbacks */
  onBack: () => void;
  onSubmit: (data: MallCreatePageFormData) => void;
}

const MallCreatePage: React.FC<MallCreatePageProps> = ({
  disabled,
  errors,
  saveButtonBarState,
  hasManageMallPermission,
  onBack,
  onSubmit
}) => {
  // Form Validation
  const initialFormValidation = {
    city: null,
    code: null,
    contactPerson: null,
    email: null,
    latitude: null,
    longitude: null,
    mallClosing: null,
    mallOpening: null,
    mobileNo: null,
    name: null,
    provinceCode: null,
    serviceArea: null,
    smMarketExternalCode: null,
    smMarketExternalId: null,
    smMarketExternalName: null,
    telephoneNo: null,
    totalLandArea: null
  };
  const [clientErrors, setClientErrors] = useState(initialFormValidation);

  const handleSubmit = event => {
    const validate = useValidation(event);

    if (hasNoError(validate)) {
      setClientErrors(validate);
      onSubmit(event);
    } else {
      setClientErrors(validate);
    }
  };

  return (
    <Form initial={initialForm} onSubmit={handleSubmit} confirmLeave>
      {({ data, change, submit, hasChanged }) => (
        <>
          <div>
            <MallInfo
              data={data}
              clientErrors={clientErrors}
              errors={errors}
              onChange={change}
              disabled={disabled}
              hasManageMallPermission={hasManageMallPermission}
            />
          </div>
          <div>
            <SaveButtonBar
              onCancel={onBack}
              onSave={submit}
              state={saveButtonBarState}
              disabled={disabled || !hasChanged}
            />
          </div>
        </>
      )}
    </Form>
  );
};
MallCreatePage.displayName = "MallCreatePage";
export default MallCreatePage;
